export const BIC_SWIFT_REGEX: RegExp = /^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/g
